export default {
  title: 'Alérgenos',
  description: 'Ten en cuenta que este {{product}} puede contener los siguientes ingredientes o sus derivados:',
  options: {
    dairy: 'Lácteos/Leche',
    eggs: 'Huevos',
    fish: 'Pescado',
    gluten: 'Gluten',
    mango: 'Mango',
    peanuts: 'Cacahuetes',
    sesame: 'Sésamo',
    shellfish: 'Mariscos',
    soy: 'Soja',
    tree_nuts: 'Frutos secos de árbol',
    celery: 'Apio',
    crustaceans: 'Crustáceos',
    lupin: 'Altramuz',
    molluscs: 'Moluscos',
    mustard: 'Mostaza',
    nuts: 'Frutos secos',
    sulphites: 'Sulfitos',
    almonds: 'Almendras',
    barley: 'Cebada',
    brazil_nuts: 'Nueces de Brasil',
    cashew: 'Anacardos',
    hazelnuts: 'Avellanas',
    kamut: 'Kamut',
    macadamia: 'Nueces de macadamia',
    oats: 'Avena',
    pecan: 'Nueces pecanas',
    pistachios: 'Pistachos',
    rye: 'Centeno',
    spelt: 'Espelta',
    walnuts: 'Nueces',
    wheat: 'Trigo',
    sugared_drink: 'Bebida azucarada',
    lentils: 'Lentejas',
    queensland_nuts: 'Nueces de Queensland',
  },
};
